<template>
    <div>
        <div class="flex justify-end my-2">
            <el-button size="mini" type="primary" @click="handleSubmit()"
                v-if="this.status != 1 && this.status != 2 && this.status != 3 && this.userInfo.userType != '2'">{{
                    this.$route.query.pageStatus == 2 ?
                        'Submit'
                        : 'Save' }}</el-button>
            <el-button size="mini" type="primary" @click="signDialogVisible = true"
                v-if="this.status != 1 && this.status != 2 && this.status != 3 && this.$route.query.pageStatus != 2 && this.userInfo.userType != '2'">Sign
                Holding
                Certificate</el-button>
            <el-button size="mini" type="primary" @click="handleInvalidateCert()"
                v-if="(this.status == 1 || this.status == 3) && this.userInfo.userType != '2'">Invalidate
                Holding Certificate</el-button>
            <el-button size="mini" type="primary" @click="handleApprove()"
                v-if="this.status == 1 && this.userInfo.userType == '2' && this.status != 3">Approve</el-button>
            <el-button size="mini" type="primary" @click="handleViewPdf()"
                v-if="this.status != 2 && this.$route.query.pageStatus != 2">View in
                PDF</el-button>
            <el-button size="mini" @click="handleCloseClick">Close</el-button>
            <div class="flex items-center mx-2">
                <p class="text-xs" :style="getStatusColor(this.status)">{{ getStatusLabel(this.status) }}</p>
            </div>
        </div>

        <div class="ship-detail"
            :style="{ backgroundColor: '#ffffff', borderRadius: '10px', marginLeft: '20px', height: 'calc(108vh - 210px)', overflowY: 'auto' }">
            <div class="px-6 py-4" style="border-bottom: 1px solid #D5DDED;" v-if="this.$route.query.pageStatus == 2">
                Create a New Certificate</div>
            <div class="px-6 py-4" style="border-bottom: 1px solid #D5DDED;" v-else>Holding Certificate {{
                this.$route.query.id }}</div>

            <div class="px-8 py-4">
                <!-- Recipient Info -->
                <div class="flex flex-row py-2" style="border-bottom: 1px solid #D5DDED;">
                    <svg-icon icon-class="certificate-of-quantity"></svg-icon>
                    <p class="px-2">Recipient Information</p>
                </div>

                <el-row :gutter="30">
                    <!-- Terminal -->
                    <el-col :span="8">
                        <h4 class="py-2">Terminal</h4>
                        <el-form ref="terminalForm" :model="form.terminal" :rules="rules.terminal" size="small"
                            :label-width="isMobileScreen ? null : '160px'" label-position="left" :disabled="disabled">
                            <el-form-item label="Terminal Name" prop="name" required>
                                <el-input size="mini" v-model="form.terminal.name" />
                            </el-form-item>
                            <el-form-item label="Address Line 1" prop="address1">
                                <el-input size="mini" v-model="form.terminal.address1" />
                            </el-form-item>
                            <el-form-item label="Address Line 2" prop="address2">
                                <el-input size="mini" v-model="form.terminal.address2" />
                            </el-form-item>
                            <el-form-item label="Address Line 3" prop="address3">
                                <el-input size="mini" v-model="form.terminal.address3" />
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <!-- Bank -->
                    <el-col :span="8">
                        <h4 class="py-2">Bank</h4>
                        <el-form ref="bankForm" :model="form.bank" :rules="rules.bank" size="small"
                            :label-width="isMobileScreen ? null : '160px'" label-position="left" :disabled="disabled">
                            <el-form-item label="Bank Name" prop="name" required>
                                <el-input size="mini" v-model="form.bank.name" />
                            </el-form-item>
                            <el-form-item label="Address Line 1" prop="address1">
                                <el-input size="mini" v-model="form.bank.address1" />
                            </el-form-item>
                            <el-form-item label="Address Line 2" prop="address2">
                                <el-input size="mini" v-model="form.bank.address2" />
                            </el-form-item>
                            <el-form-item label="Address Line 3" prop="address3">
                                <el-input size="mini" v-model="form.bank.address3" />
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <!-- Customer -->
                    <el-col :span="8">
                        <h4 class="py-2">Customer</h4>
                        <el-form ref="customerForm" :model="form.customer" :rules="rules.customer" size="small"
                            :label-width="isMobileScreen ? null : '160px'" label-position="left" :disabled="disabled">
                            <el-form-item label="Customer Name" prop="id" required>
                                <el-select v-model="form.customer.id" placeholder=" ">
                                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName"
                                        :value="item.id" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Address Line 1" prop="address1">
                                <el-input size="mini" v-model="form.customer.address1" />
                            </el-form-item>
                            <el-form-item label="Address Line 2" prop="address2">
                                <el-input size="mini" v-model="form.customer.address2" />
                            </el-form-item>
                            <el-form-item label="Address Line 3" prop="address3">
                                <el-input size="mini" v-model="form.customer.address3" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>

            <!-- General Info -->
            <div class="px-8 py-4">
                <div class="flex flex-row py-2" style="border-bottom: 1px solid #D5DDED;">
                    <svg-icon icon-class="certificate-of-quantity"></svg-icon>
                    <p class="px-2">General Information</p>
                </div>

                <el-form :model="form" :rules="rules" size="small" :label-width="isMobileScreen ? null : '220px'"
                    class="py-4" label-position="left" :disabled="true">
                    <el-form-item label="Storage Contract Date" prop="contractDate">
                        <el-date-picker v-model="form.contractDate" type="date" size="mini" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" clearable />
                    </el-form-item>
                </el-form>

                <!-- Dynamic Table -->
                <div>
                    <div class="flex flex-row py-2 justify-between">
                        <p>We confirm that we currently hold Pledge Products in our storage tanks in approximate barrels
                            as follows:</p>
                        <el-button size="mini" type="primary" @click="addProductRow" plain
                            :disabled="disabled || !form.customer.id">Add
                            Row</el-button>
                    </div>

                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="text-left">
                                <th class="p-2 w-[120px]">Tank Number</th>
                                <th class="p-2 w-[120px]">Product</th>
                                <th class="p-2 w-[120px]">Quantity (Bbls)</th>
                                <th class="p-2 w-10" v-if="productRow.length > 1 && !disabled"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(row, index) in productRow" :key="index">
                                <td class="p-2">
                                    <el-select v-model="row.tankNumber" size="small" clearable
                                        :disabled="disabled || !form.customer.id" class="w-full"
                                        popper-class="tank-select-dropdown" @change="onTankNumberChange(row)"
                                        @visible-change="handleTankDropdownVisible">
                                        <el-option v-for="item in tankOptions" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                        <div v-if="tankLoading" style="padding: 10px; text-align: center;">
                                            <i class="el-icon-loading" style="font-size:18px;color:#409EFF"></i>
                                        </div>
                                        <div v-else-if="tankFinished && tankOptions.length > 0"
                                            style="padding: 8px; text-align: center; color: #999;">

                                        </div>
                                    </el-select>
                                </td>
                                <td class="p-2" style="width: 100%;">
                                    <el-select v-model="row.product" size="small" clearable style="width: 100%;"
                                        :disabled="true">
                                        <el-option v-for="item in productOptions" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </td>
                                <td class="p-2">
                                    <el-input v-model="row.quantity" size="small" :disabled="true" />
                                </td>
                                <td class="p-2" v-if="productRow.length > 1 && !disabled">
                                    <div class="flex items-center justify-center space-x-2">
                                        <i class="el-icon-delete cursor-pointer text-red-500"
                                            @click="delProductRow(index)"></i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="attachment-section mt-8">
                    <div class="flex justify-between items-center mb-2">
                        <p>
                            Additional Attachment
                            <small>(Attachments uploaded will be combined into a PDF file with the Holding
                                Cert.)</small>
                        </p>

                        <el-upload :show-file-list="false" multiple accept=".pdf" :before-upload="() => false"
                            :on-change="handleFileChange">
                            <el-button type="primary" size="mini" plain :disabled="disabled">
                                Upload Attachment
                            </el-button>
                        </el-upload>


                    </div>
                    <div v-if="attachments.length == 0" class="text-center h-24">
                    </div>

                    <table class="table table-striped" v-if="attachments.length > 0">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="w-64 p-2">Page Number
                                    <span class="text-xs">(After Holding Cert.)</span>
                                </th>
                                <th scope="col" class="p-2">File Name</th>
                                <th scope="col" class="w-20" v-if="!disabled"></th>
                            </tr>
                        </thead>
                        <tr v-for="(item, index) in sortedAttachments" :key="item.id || item.fileName">
                            <td scope="row" class="w-20 p-2">
                                <p>{{ item.pageNumber }}</p>
                            </td>
                            <td class="p-2" @click="handleAttachmentView(item)">{{ item.fileName }}</td>
                            <td class="w-20 p-2" v-if="!disabled">
                                <div class="flex items-center justify-center space-x-2">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                        @click="removeRow(index)" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="mx-8 my-2 f-500" style="color:#4C565C "
                v-if="this.$route.query.pageStatus == 1 && sign?.eSignature">
                Signature
            </div>
            <div class="flex flex-wrap w-full xl:w-1/2 mx-8 my-2 justify-between"
                v-if="this.$route.query.pageStatus == 1 && sign?.eSignature">
                <div class="w-full sm:w-1/2 ">
                    <div class="mt-4 f-600" style="font-size: 12px">
                        <span>Date and Time:</span>
                        <span class="ml-2">{{ sign.createTime }}</span>
                    </div>
                    <div class="mt-4 f-600 flex" style="font-size: 12px">
                        <span>Signature:</span>
                        <img v-if="sign?.eSignature" :src="sign?.eSignature" class="ml-2" style="width: 100px;" />
                    </div>
                </div>
            </div>
        </div>
        <pdf-view v-if="holdingCertUrl" :title="'Holding Cert'" :pdf-url="holdingCertUrl" v-model="showPdfView" />
        <pdf-view v-if="attachmentUrl" :key="attachmentUrl" :title="'Attachment'" :pdf-url="attachmentUrl"
            v-model="showAttachmentPdfView" />

        <el-dialog title="E-Signature" :visible.sync="signDialogVisible" width="400px" @close="clearSignature">
            <vue-sign ref="signaturePad" />

            <div class="flex justify-end mt-4">
                <el-button @click="clearSignature">Clear</el-button>
                <el-button type="primary" @click="handleSign">Save</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import { createHoldingCert, generateHoldingCertPdf, getHoldingCertDetail, getTankBookStockList, invalidateHoldingCert, signHoldingCert, updateHoldingCert, uploadHoldingCertFile } from '@/services/form';
import draggable from "vuedraggable";
import PdfView from "@/components/common/pdf-view.vue";
import { allCompanyList, approveHoldingCert, getProductList, singleleUploadFile } from '@/services';
import VueSign from '@/components/vue-sign.vue';
import { uuid } from '@/utils/uuid';
import { mapState } from 'vuex';

export default {
    components: { SvgIcon, draggable, PdfView, VueSign },
    data() {
        return {
            productRow: [],
            form: {
                terminal: {
                    name: 'Jurong Port Tank Terminal Private Limited',
                    address1: '37 Jurong Port Road,',
                    address2: 'Singapore 619110',
                    address3: '',
                },
                bank: {
                    name: 'DBS Bank Ltd',
                    address1: '12 Marina Boulevard, DBS Asia Central,',
                    address2: 'Marina Bay Financial Centre Tower 3',
                    address3: 'Singapore 018982',
                },
                customer: {
                    id: '',
                    name: '',
                    address1: '',
                    address2: '',
                    address3: '',
                },
                contractDate: new Date().toISOString().slice(0, 10),
            },
            rules: {
                terminal: { name: [{ required: true, message: '', trigger: 'blur' }] },
                bank: { name: [{ required: true, message: '', trigger: 'blur' }] },
                customer: { id: [{ required: true, message: '', trigger: 'blur' }] },
            },
            attachments: [],
            rawFileList: [],
            deleteFileIds: [],
            deletedTankIds: [],
            showPdfView: false,
            holdingCertUrl: '',
            signDialogVisible: false,
            status: null,
            sign: null,
            statusList: [
                { label: "Draft", value: "0" },
                { label: "Signed", value: "1" },
                { label: "Invalidated", value: "2" },
                { label: "Approved", value: "3" },
            ],
            showAttachmentPdfView: false,
            productOptions: [
            ],
            formChanged: false,
            customerList: [
            ],
            tankOptions: [
            ],
            tankPageNum: 1,
            tankPageSize: 10,
            tankTotal: 0,
            tankLoading: false,
            tankFinished: false,
            attachmentUrl: "",
            lastAttachmentBlobUrl: null,
            addressList: [
                {
                    name: 'PetroChina',
                    address1: 'One Temasek Avenue',
                    address2: '#27-00',
                    address3: 'Millenia Tower, Singapore 039192',
                },
                {
                    name: 'BP',
                    address1: '7 Straits View',
                    address2: '#26-01',
                    address3: 'Marina One East Tower, Singapore 018396'
                },
                {
                    name: 'Gunvor',
                    address1: '128 Beach Road',
                    address2: '#29-01',
                    address3: 'Guoco Midtown, Singapore 189773'
                }
            ],
            isLoadingDetail: false,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        sortedAttachments() {
            return [...this.attachments].sort(
                (a, b) => Number(a.pageNumber) - Number(b.pageNumber)
            );
        },
        combinedForm() {
            const isSingleEmptyRow =
                this.productRow.length === 1 &&
                Object.values(this.productRow[0]).every(
                    val => !val || val === null || val === ''
                );
            return {
                fromCompany: this.form.terminal.name,
                fromAddress1: this.form.terminal.address1,
                fromAddress2: this.form.terminal.address2,
                fromAddress3: this.form.terminal.address3,
                toCompany: this.form.bank.name,
                toAddress1: this.form.bank.address1,
                toAddress2: this.form.bank.address2,
                toAddress3: this.form.bank.address3,
                copyCompanyId: this.form.customer.id,
                copyCompany: this.customerList.find(c => c.id === this.form.customer.id)?.companyName || "",
                copyAddress1: this.form.customer.address1,
                copyAddress2: this.form.customer.address2,
                copyAddress3: this.form.customer.address3,
                date: this.form.contractDate ?? "",
                tanks: isSingleEmptyRow
                    ? []
                    : this.productRow.map(r => ({
                        id: r.id,
                        tankNumber: r.tankNumber,
                        product: r.product,
                        quantity: r.quantity
                    }))
            };
        },
        disabled() {
            return this.status == 1 || this.status == 2 || this.userInfo.userType == '2' || this.status == 3;
        },
    },
    async mounted() {
        await this.getCustomerList();
        this.getProductList();

        if (this.$route.query.id) {
            await this.getDetail();
        }

        if (this.productRow.length === 0) {
            this.addProductRow();
        }
    },

    watch: {
        '$route.query.id': {
            immediate: true,
            async handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    await this.getDetail();
                }
            }
        },

        'form.customer.id': {
            handler(newId, oldId) {
                if (!newId) {
                    this.tankOptions = [];
                    this.tankPageNum = 1;
                    this.tankTotal = 0;
                    this.tankFinished = false;
                    return;
                }

                if (!this.customerList.length) return;

                this.getTankOptions(true);

                if (!this.isLoadingDetail && oldId && newId !== oldId) {
                    this.productRow = [];
                    this.addProductRow();
                }

                const companyName =
                    this.customerList.find(c => c.id === newId)?.companyName || "";

                if (companyName && !this.isLoadingDetail) {
                    this.getDefaultAddress(companyName);
                }
            }
        },

        form: {
            handler() {
                this.formChanged = true;
            },
            deep: true
        },

        productRow: {
            handler() {
                this.formChanged = true;
            },
            deep: true
        },

        attachments: {
            deep: true,
            handler(newVal) {
                const sorted = [...newVal].sort(
                    (a, b) => Number(a.pageNumber) - Number(b.pageNumber)
                );

                sorted.forEach((a, i) => {
                    a.pageNumber = i + 1;
                });

                const changed = JSON.stringify(sorted) !== JSON.stringify(newVal);
                if (changed) {
                    this.attachments = sorted;
                    return;
                }

                this.formChanged = true;
            }
        }
    },
    methods: {
        getDefaultAddress(name) {
            const n = (name || "").toLowerCase().trim();
            if (!n) return;

            const item = this.addressList.find(addr => {
                const a = (addr.name || "").toLowerCase().trim();
                return a.includes(n) || n.includes(a);
            });

            if (item) {
                this.form.customer.address1 = item.address1 || "";
                this.form.customer.address2 = item.address2 || "";
                this.form.customer.address3 = item.address3 || "";
            }
        },
        onTankNumberChange(row) {
            if (!row.tankNumber) {
                row.product = '';
                row.quantity = '';
                return;
            }

            const selectedTank = this.tankOptions.find(
                t => t.value === row.tankNumber
            );

            if (selectedTank) {
                row.product = selectedTank.product || '';
                row.quantity = selectedTank.metricTon || '';
            } else {
                row.product = '';
                row.quantity = '';
            }
        },
        getProductList() {
            getProductList().then((res) => {
                this.productOptions = res.data.map(item => ({
                    label: item.productName,
                    value: item.productName
                }));
            });
        },
        addProductRow() {
            this.productRow.push({
                tankNumber: '',
                product: '',
                quantity: ''
            });
        },
        delProductRow(index) {
            const removedProduct = this.productRow[index];

            if (this.productRow.length > 1) {
                this.productRow.splice(index, 1);
            } else {
                this.$message.warning("At least one product row is required.");
                return;
            }

            if (this.$route.query.id && removedProduct?.id) {
                this.deletedTankIds.push(removedProduct.id);
            }
        },
        handleFileChange(file, fileList) {
            const allowedType = "application/pdf";

            const validFiles = fileList.filter(f => {
                const raw = f.raw;
                const isPdfMime = raw && raw.type === allowedType;
                const ext = (f.name || "").split(".").pop().toLowerCase();
                const isPdfExt = ext === "pdf";

                const isAllowed = isPdfMime || isPdfExt;
                if (!isAllowed) {
                    this.$message.error(`Only PDF files are allowed.`);
                }
                return isAllowed;
            });

            validFiles.forEach(f => {
                if (this.attachments.some(a => a.fileName === f.name)) {
                    this.$message.info(`File "${f.name}" already added.`);
                    return;
                }
                this.attachments.push({
                    pageNumber: this.attachments.length + 1,
                    fileName: f.name,
                });
                this.rawFileList.push(f.raw);
            });
        },
        removeRow(index) {
            const removedFile = this.attachments[index];
            this.attachments.splice(index, 1);

            if (!removedFile?.id) {
                const rawIndex = this.rawFileList.findIndex(
                    (f) => f.name === removedFile.fileName
                );
                if (rawIndex !== -1) {
                    this.rawFileList.splice(rawIndex, 1);
                }
            }

            if (this.$route.query.id && removedFile?.id) {
                this.deleteFileIds.push(removedFile.id);
            }

            this.reassignPageNumbers();
        }
        ,
        onDragEnd(evt) {
            this.reassignPageNumbers();
            const newOrder = evt.to.children;
            const reorderedRawFiles = [];
            Array.from(newOrder).forEach((tr) => {
                const fileName = tr.querySelector('td:nth-child(2)')?.innerText.trim();
                const matched = this.rawFileList.find((f) => f.name === fileName);
                if (matched) reorderedRawFiles.push(matched);
            });
            this.rawFileList = reorderedRawFiles;
        },
        reassignPageNumbers() {
            this.attachments.forEach((item, index) => {
                item.pageNumber = index + 1;
            });
        },
        async handleSubmit() {
            const validateAll = async () => {
                const refs = [this.$refs.terminalForm, this.$refs.bankForm, this.$refs.customerForm];
                let allValid = true;

                for (const ref of refs) {
                    if (ref && typeof ref.validate === "function") {
                        const valid = await ref.validate().catch(() => false);
                        if (!valid) allValid = false;
                    }
                }

                return allValid;
            };

            const valid = await validateAll();
            if (!valid) {
                this.$message.warning("Please complete all required fields before saving.");
                return;
            }

            try {
                const filteredProductRow = this.productRow.filter(row => {
                    const tank = row.tankNumber ? row.tankNumber.toString().trim() : "";
                    const product = row.product ? row.product.toString().trim() : "";
                    const qty = row.quantity ? row.quantity.toString().trim() : "";
                    return tank !== "" || product !== "" || qty !== "";
                });

                const payload = {
                    ...this.combinedForm,
                    tanks: filteredProductRow,
                    id: this.$route.query.id || null,
                    deletedTankIds: this.deletedTankIds,
                };

                if (this.$route.query.pageStatus == 2) {
                    delete payload.id
                    const res = await createHoldingCert(payload);
                    if (res) {
                        this.$message.success("Holding Certificate created successfully.");
                        const newId = res.data || "";

                        if (this.rawFileList.length > 0) {
                            this.rawFileList = this.rawFileList.filter(raw =>
                                this.attachments.some(a => a.fileName === raw.name)
                            );
                            await uploadHoldingCertFile(newId, this.rawFileList, []);
                            this.$message.success("Attachments uploaded successfully.");
                        }

                        this.rawFileList = [];
                        this.deleteFileIds = [];

                        if (newId) {
                            this.$router.push({
                                path: "/holdingCertificate/index",
                                query: {
                                    id: newId,
                                    pageStatus: 1,
                                },
                            });
                            sessionStorage.setItem("pageStatus", 1);

                            this.$nextTick(() => {
                                this.addProductRow();
                            });

                            return;
                        }

                    }
                } else if (this.$route.query.pageStatus == 1 && this.$route.query.id) {
                    const res = await updateHoldingCert(payload);
                    if (res) {
                        this.$message.success("Holding Certificate updated successfully.");

                        if (this.rawFileList.length > 0 || this.deleteFileIds.length > 0) {
                            this.rawFileList = this.rawFileList.filter(raw =>
                                this.attachments.some(a => a.fileName === raw.name)
                            );
                            await uploadHoldingCertFile(
                                this.$route.query.id,
                                this.rawFileList,
                                this.deleteFileIds
                            );
                            this.$message.success("Files updated successfully.");
                        }

                        this.rawFileList = [];
                        this.deleteFileIds = [];
                        this.$nextTick(async () => {
                            await this.getDetail();
                        });
                    }
                }
            } catch (error) {
                console.error("Error submitting Holding Certificate:", error);
                this.$message.error("Error submitting Holding Certificate.");
            }
        },
        handleCloseClick() {
            this.pageStatus = 0;
            if (this.$route.query.pageStatus == 2) {
                this.requestData = {};
            }
            this.$router.push({ path: "/holdingCertificate/index" });
            setTimeout(() => {
                if (this.$route.path == "/holdingCertificate/index" && this.$route.query.id) {
                    this.$router.push({ path: "/holdingCertificate/index" });
                }
            }, 500);
        },
        async getSignFile() {
            return new Promise((resolve, reject) => {
                this.$refs.signaturePad.generate().then((res) => {
                    var arr = res.split(","),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    let file = new File([u8arr], `${uuid()}.png`, { type: mime });
                    resolve(file);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        async handleSign() {
            try {
                if (this.formChanged) {
                    await this.handleSubmit();
                    this.formChanged = false;
                }
                const file = await this.getSignFile()
                const uploadRes = await singleleUploadFile(file);
                const imageUrl = uploadRes.url;

                const payload = {
                    id: this.$route.query.id,
                    esignature: imageUrl,
                };

                await signHoldingCert(payload);
                this.signDialogVisible = false;
                this.$nextTick(async () => {
                    this.getDetail();
                });


            } catch (err) {
                console.error(err);
                this.$message.error('Failed to upload signature.');
            }
        },
        async handleViewPdf() {
            if (this.$route.query.id) {
                const response = await generateHoldingCertPdf(this.$route.query.id);
                const blob = new Blob([response], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(blob);
                this.holdingCertUrl = fileURL;
                this.pdfDialogVisible = true;
                this.showPdfView = true;
            } else {
                this.$message.warning("Please submit the Holding Cert first to view the PDF.");
            }
        },
        clearSignature() {
            this.$refs.signaturePad?.reset();
        },
        getStatusLabel(value) {
            const found = this.statusList.find(s => s.value === String(value));
            return found ? found.label : value;
        },
        getStatusColor(value) {
            switch (value) {
                case 1:
                case 3:
                    return { color: "#4CAF50" }; // Signed - Green
                case 2:
                    return { color: "#F44336" }; // Invalidated - Red
                default:
                    return { color: "#000000" }; // Default - Black
            }
        },
        async handleInvalidateCert() {
            if (this.$route.query.id) {
                try {
                    await invalidateHoldingCert(this.$route.query.id);
                    this.$message.success('Holding Certificate invalidated successfully.');
                    this.getDetail();
                } catch (error) {
                    console.error('Error invalidating Holding Cert:', error);
                    this.$message.error('Error invalidating Holding Certificate.');
                }
            }
        },
        handleAttachmentView(file) {
            this.showAttachmentPdfView = true;
            if ((file.documentUrl && file.id)) {
                this.attachmentUrl = process.env.VUE_APP_BASE_API + file.documentUrl;
                return;
            }
            const raw = this.rawFileList.find(f => f && f.name === file.fileName);
            if (!raw) {
                this.$message.warning("Attachment file not found locally. Please refresh.");
                return;
            }
            const blob = raw instanceof Blob ? raw : raw.raw;
            if (!blob) {
                this.$message.warning("Invalid attachment blob.");
                return;
            }
            this.attachmentUrl = URL.createObjectURL(blob);
        },
        async handleApprove() {
            if (this.formChanged) {
                await approveHoldingCert(this.$route.query.id);
                this.formChanged = false;
            }
            this.$message.success('Holding Certificate approved successfully.');
            this.getDetail();
        },
        async getCustomerList() {
            const res = await allCompanyList({ role: 4 });
            this.customerList = res.data || [];

            const companyName =
                this.customerList.find(c => c.id === this.form.customer.id)?.companyName || "";

            if (companyName) {
                this.getDefaultAddress(companyName);
            }
        },

        async getTankOptions(reset = false) {
            const customerName =
                this.customerList.find(c => c.id === this.form.customer.id)?.companyName || "";

            if (!customerName) {
                this.tankOptions = [];
                this.tankPageNum = 1;
                this.tankTotal = 0;
                this.tankFinished = true;
                return;
            }

            if (this.tankLoading) return;
            if (!reset && this.tankFinished) return;

            if (reset) {
                this.tankPageNum = 1;
                this.tankTotal = 0;
                this.tankFinished = false;
                this.tankOptions = [];
            }

            this.tankLoading = true;

            try {
                const res = await getTankBookStockList({
                    customer: customerName,
                    pageNum: this.tankPageNum,
                    pageSize: this.tankPageSize,
                });

                const rows = res?.data?.rows || [];
                const total = Number(res?.data?.total || 0);

                const mappedRows = rows.map((item, index) => ({
                    key: `${item.tankName}-${this.tankPageNum}-${index}`,
                    label: item.tankName,
                    value: item.tankName,
                    product: item.product,
                    metricTon: item.metricTon
                }));

                this.tankOptions = reset
                    ? mappedRows
                    : [...this.tankOptions, ...mappedRows];

                this.tankTotal = total;

                if (rows.length < this.tankPageSize || this.tankOptions.length >= total) {
                    this.tankFinished = true;
                } else {
                    this.tankPageNum += 1;
                }
            } catch (error) {
                console.error("Error loading tank options:", error);
                this.tankOptions = [];
            } finally {
                this.tankLoading = false;
            }
        },

        async getDetail() {
            this.isLoadingDetail = true;
            try {
                if (!this.customerList.length) {
                    await this.getCustomerList();
                }

                const res = await getHoldingCertDetail({ certId: this.$route.query.id });
                const data = res.data.holdingCert;
                const files = res.data.files || [];

                this.form.terminal.name = data.fromCompany;
                this.form.terminal.address1 = data.fromAddress1;
                this.form.terminal.address2 = data.fromAddress2;
                this.form.terminal.address3 = data.fromAddress3;

                this.form.bank.name = data.toCompany;
                this.form.bank.address1 = data.toAddress1;
                this.form.bank.address2 = data.toAddress2;
                this.form.bank.address3 = data.toAddress3;

                this.form.customer.name = data.copyCompany;
                this.form.customer.address1 = data.copyAddress1;
                this.form.customer.address2 = data.copyAddress2;
                this.form.customer.address3 = data.copyAddress3;
                this.form.customer.id = data.copyCompanyId;

                this.form.contractDate = data.date;
                this.status = data.status;
                this.sign = {
                    createTime: data.signTime,
                    eSignature: data.esignature,
                };

                this.productRow = (data?.tanks || []).map(tank => ({
                    id: tank.id,
                    tankNumber: tank.tankNumber,
                    product: tank.product,
                    quantity: tank.quantity
                }));

                this.attachments = files.map((att, index) => ({
                    id: att.id,
                    pageNumber: index + 1,
                    fileName: att.originalFileName.split("/").pop(),
                    documentUrl: att.documentUrl
                }));

                if (this.productRow.length === 0) {
                    this.addProductRow();
                }

                await this.getTankOptions(true);
            } finally {
                this.isLoadingDetail = false;
            }
        },

        handleTankDropdownVisible(visible) {
            if (!visible) return;

            this.$nextTick(() => {
                const dropdownWrap = document.querySelector(
                    '.tank-select-dropdown .el-select-dropdown__wrap'
                );

                if (!dropdownWrap) return;

                dropdownWrap.removeEventListener('scroll', this.handleTankScroll);
                dropdownWrap.addEventListener('scroll', this.handleTankScroll);
            });
        },

        handleTankScroll(e) {
            const el = e.target;
            const reachBottom =
                el.scrollHeight - el.scrollTop <= el.clientHeight + 10;

            if (reachBottom && !this.tankLoading && !this.tankFinished) {
                this.getTankOptions(false);
            }
        },
    }
};
</script>

<style scoped>
table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    text-align: left;
    border: 1px solid #e5e7eb;
}

th {
    background-color: #f5f7fa;
}


.cursor-pointer {
    cursor: pointer;
}

.text-red-500 {
    color: red;
}

.tank-select-dropdown .el-icon-loading {
  animation: rotating 1s linear infinite;
}
</style>